module.exports = __webpack_public_path__ + "media/images/whychoose-6ab704656d838cedcaadb5a9908ec5d2.png";